export interface Article {
  id: string;
  title: string;
  summary: string;
  date: string;
  content: string;
  image?: string;
}

export const articles: Article[] = [
  {
    id: "guia-de-senhas-seguras",
    title: "O Guia Essencial para Senhas Seguras",
    summary:
      "Descubra por que senhas fortes são a primeira linha de defesa contra ameaças online e aprenda a criar e gerenciar credenciais impenetráveis.",
    date: "16 de Setembro de 2025",
    content: `
      <p>Em um mundo cada vez mais conectado, a segurança digital deixou de ser um luxo e se tornou uma necessidade. E a primeira e mais importante barreira de proteção entre suas informações pessoais e os cibercriminosos é algo que muitos de nós subestimamos: a senha.</p>
      
      <h2>Por que senhas fracas são um convite para hackers?</h2>
      <p>A maioria das pessoas utiliza senhas curtas, previsíveis ou que são fáceis de lembrar, como "123456", "senha" ou "fulano123". No entanto, os hackers utilizam ferramentas automatizadas, como ataques de força bruta, que testam milhões de combinações por segundo. Uma senha fraca pode ser descoberta em questão de segundos, deixando suas contas completamente vulneráveis.</p>
      
      <h2>O que torna uma senha realmente segura?</h2>
      <p>Uma senha segura é longa, imprevisível e única para cada conta. Siga estas diretrizes para criar uma senha impenetrável:</p>
      
      <ul>
        <li>**Comprimento:** O ideal é ter no mínimo 12 caracteres.</li>
        <li>**Complexidade:** Use uma mistura de letras maiúsculas e minúsculas, números e símbolos.</li>
        <li>**Originalidade:** Nunca use a mesma senha em contas diferentes. Se uma for comprometida, as outras estarão seguras.</li>
        <li>**Evite informações pessoais:** Não use nomes, datas de aniversário, números de telefone ou qualquer dado que possa ser facilmente descoberto.</li>
      </ul>
      
      <h2>Como gerenciar tantas senhas?</h2>
      <p>Criar senhas seguras para cada conta pode parecer uma tarefa impossível. É aí que entra a importância de um gerenciador de senhas. Com o Gerenciador de Senhas Fidelius, você pode gerar senhas complexas com um clique e armazená-las de forma segura em um cofre digital, acessível apenas por uma única senha mestra.</p>
      
      <p>Lembre-se: sua segurança online começa com você. Use esta ferramenta para fortalecer a sua primeira linha de defesa e proteger o que é mais importante.</p>
    `,
    image: "https://via.placeholder.com/1000x400",
  },
];
